import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { z } from 'zod'

// import { getImage } from '@/lib/utils'

export const tokenIconAccept = [
  'image/jpg',
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/bmp'
]

export const staticSchems = {
  urlSchema: z
    .string()
    .trim()
    .refine((val) => {
      return /^http(s)?:\/\/.+$/.test(val)
    })
}


export const useDynamicSchems = () => {
  const { t } = useTranslation()
  const zodSchemas = useMemo(()=>{
    return {
      tokenIcon: z
        .instanceof(File, { message: t('create.message.requiredCoinIcon') })
        .superRefine(async (file: File, ctx) => {
          if (!tokenIconAccept.includes(file.type)) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              message: t('create.message.invalidImageType'),
            });
            return false;
          }
          if (file.size > 5 * 1024 * 1024) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              message: t('create.message.invalidImageLimit'),
            });
            return false;
          }
          // const image = await getImage(file).catch(()=>undefined)
          // if(!image || image.width > 800 || image.height > 800){
          //   ctx.addIssue({
          //     code: z.ZodIssueCode.custom,
          //     message: t('create.message.invalidImageSize'),
          //   });
          //   return false;
          // }
          return file;
        }),

      website: z
        .string()
        .trim()
        .refine((val) => {
          return val.length === 0 ? true : /^http(s)?:\/\/.+$/.test(val)
        }, t('create.message.invalidWebsite')),
  
      twitter: z
        .string()
        .trim()
        .refine((val) => {
          return val.length === 0 ? true : /^http(s)?:\/\/(twitter|x).com\/.+$/.test(val)
        }, t('create.message.invalidTwitter')),
  
      telegram: z
        .string()
        .trim()
        .refine((val) => {
          return val.length === 0 ? true : /^http(s)?:\/\/t.me\/.+$/.test(val)
        }, t('create.message.invalidTelegram')),
  
      discord: z
        .string()
        .trim()
        .refine((val) => {
          return val.length === 0 ? true : /^http(s)?:\/\/discord.\w+\/.+$/.test(val)
        }, t('create.message.invalidDiscord')),

      github: z
        .string()
        .trim()
        .refine((val) => {
          return val.length === 0 ? true : /^http(s)?:\/\/github.com\/.+$/.test(val)
        }, t('create.message.invalidGithub')),
    }
  }, [t])

  return {
    zodSchemas,
  }
}

export default useDynamicSchems

